<template>
  <v-container fluid>
    <v-layout wrap>
      <v-flex xs6>
        <v-btn color="primary" @click="loadIndicators()">refresh</v-btn>
      </v-flex>
      <v-flex xs6>
        <v-select v-model="period" :items="periods" item-text="title" item-value="id" />
      </v-flex>
      <v-flex xs12>
        <v-data-table class="elevation-1" :headers="headersForIndicators" :items="itemsForIndicators" item-key="id" :hide-actions="true" no-data-text="Список индикаторов пуст" :expand="false" :loading="loadingIndicators">
          <template v-slot:items="indicatorRow">
            <tr v-if="indicatorRow.item.type === 'category'">
              <td :colspan="headersForIndicators.length"><b>{{ indicatorRow.item.sequence }}. {{ indicatorRow.item.title[locale] }}</b></td>
            </tr>
            <tr v-else-if="!indicatorRow.item.parent">
              <td colspan="2">{{ categoryById(indicatorRow.item.category).sequence }}.{{ indicatorRow.item.sequence }}. {{ indicatorRow.item.title[locale] }}</td>
              <td>
                <template v-if="!indicatorRow.item.children">
                  <award-field
                      :indicator="indicatorRow.item"
                      :value="indicatorRow.item.award"
                  />
                </template>
              </td>
              <td>
                <template v-if="!indicatorRow.item.children">
                  <v-icon v-if="indicatorRow.item.planned">check</v-icon>
                </template>
              </td>
              <td>
                <v-tooltip top>
                  <template #activator="{ on }">
                    <v-icon v-if="indicatorRow.item.single" v-on="on">repeat-one</v-icon>
                    <v-icon v-else  v-on="on">dynamic_feed</v-icon>
                  </template>
                  <span v-if="indicatorRow.item.single">Одинарные значения</span>
                  <span v-else>Множественные значения</span>
                </v-tooltip>

                <v-tooltip v-if="indicatorRow.item.kpi" top>
                  <template #activator="{ on }">
                    <v-icon v-on="on" color="primary">star</v-icon>
                  </template>
                  <span>Ключевой индикатор</span>
                </v-tooltip>
              </td>
              <td>{{ indicatorRow.item.unit[locale] }}</td>
              <td>
                {{ indicatorRow.item.id }} <br>
                <small>{{ indicatorRow.item.description[locale] }}</small>
              </td>
              <td>
                <v-btn v-if="!indicatorRow.item.children" icon color="info" @click="expandIndicatorRow(indicatorRow)"><v-icon>list</v-icon></v-btn>
                <v-btn icon color="warning" @click="subIndicatorDlgOpen(indicatorRow.item)"><v-icon>add</v-icon></v-btn>
              </td>
            </tr>
            <tr v-else>
              <td></td>
              <td>
                {{ indicatorRow.item.sequence }}) {{ indicatorRow.item.title[locale] }}
              </td>
              <td>
                <award-field
                    :indicator="indicatorRow.item"
                    :value="indicatorRow.item.award"
                />
              </td>
              <td>
                <v-icon v-if="indicatorRow.item.planned">check</v-icon>
              </td>
              <td>
                <v-tooltip v-if="indicatorRow.item.kpi" top>
                  <template #activator="{ on }">
                    <v-icon v-on="on" color="primary">star</v-icon>
                  </template>
                  <span>Ключевой индикатор</span>
                </v-tooltip>
              </td>
              <td></td>
              <td>
                {{ indicatorRow.item.id }}
              </td>
              <td>
                <v-btn icon color="info" @click="expandIndicatorRow(indicatorRow)"><v-icon>list</v-icon></v-btn>
              </td>
            </tr>
          </template>
          <template v-slot:expand="indicatorRow">
            <v-container class="elevation-2" fluid v-if="currentIndicator && currentIndicator.id === indicatorRow.item.id">
              <v-layout>
                <v-flex xs12>
                  <v-data-table class="elevation-1" :headers="headersForFields" :items="itemsForIndicatorFields" :hide-actions="true" no-data-text="Список полей пуст" :loading="loadingFieldsForIndicator">
                    <template v-slot:items="fieldsRow">
                      <td>{{ fieldsRow.item.sequence }}</td>
                      <td>{{ fieldsRow.item.title[locale] }}</td>
                      <td>{{ fieldTypes[fieldsRow.item.type] }}</td>
                      <td>
                        <ul v-if="fieldsRow.item.type === 'enum'">
                          <li v-for="item in fieldsRow.item.enums" :key="item.id" class="body-1">
                            {{ item.value[locale] }}: +{{ item.award }}
                          </li>
                        </ul>
                      </td>
                      <td>
                        <v-icon v-if="fieldsRow.item.required">check</v-icon>
                      </td>
                      <td>
                        <v-icon v-if="fieldsRow.item.listed">check</v-icon>
                      </td>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs12 text-xs-right>
                  <v-dialog v-model="field.dialog" persistent max-width="600">
                    <template v-slot:activator="{ on }">
                      <v-btn fab small color="primary" v-on="on">
                        <v-icon>add</v-icon>
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-title>
                        <span class="headline">Новое поле индикатора</span>
                      </v-card-title>
                      <v-card-text>
                        <indicator-field-form v-model="field.object" @on-validate="field.valid = $event" :reinit="field.dialog" />
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="red darken-1" flat @click="fieldDlgClose">Отмена</v-btn>
                        <v-btn color="blue darken-1" flat @click="fieldSave" :loading="field.saving">Сохранить</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-flex>
              </v-layout>
            </v-container>
          </template>
        </v-data-table>
      </v-flex>
      <v-flex xs12 text-xs-right>
        <v-dialog v-model="indicator.dialog" persistent max-width="600" lazy>
          <template v-slot:activator="{ on }">
            <v-btn fab color="primary" v-on="on">
              <v-icon>add</v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">Новый индикатор</span>
            </v-card-title>
            <v-card-text>
              <indicator-form v-model="indicator.object" @on-validate="indicator.valid = $event" :reinit="indicator.dialog" />
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" flat @click="indicatorDlgClose">Отмена</v-btn>
              <v-btn color="blue darken-1" flat @click="indicatorSave" :disabled="!indicator.valid" :loading="indicator.saving">Сохранить</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'

import { sortBySequence } from '@/plugins/helpers'

import { Indicator, IndicatorField } from '@/api/indicators'
import IndicatorForm from '@/components/forms/IndicatorForm'
import IndicatorFieldForm from '@/components/forms/IndicatorFieldForm'
import AwardField from "@/components/forms/AwardField.vue";

export default {
  components: {
    AwardField,
    IndicatorForm,
    IndicatorFieldForm,
  },
  data: () => ({
    indicator: {
      object: new Indicator(),
      saving: false,
      dialog: false,
      valid: false,
    },
    field: {
      object: new IndicatorField(),
      saving: false,
      dialog: false,
      valid: false,
    },
    period: '2022-2023',

    currentIndicator: null,

    headersForIndicators: [
      {
        text: '',
        sortable: false,
        value: null,
      },
      {
        text: 'Название',
        align: 'left',
        sortable: false,
        value: 'title',
      },
      {
        text: 'Балл',
        align: 'left',
        sortable: false,
        value: 'award',
      },
      {
        text: 'План',
        align: 'left',
        sortable: false,
        value: 'planned',
      },
      {
        text: '',
        align: 'left',
        sortable: false,
        value: null,
      },
      {
        text: 'Единицы измерения',
        align: 'left',
        sortable: false,
        value: 'unit',
      },
      {
        text: 'Пояснение к индикатору',
        align: 'left',
        sortable: false,
        value: 'description',
      },
      {
        text: '',
        sortable: false,
        value: null,
      }
    ],
    headersForFields: [
      {
        text: '№',
        sortable: false,
      },
      {
        text: 'Название поля',
        value: 'id',
        sortable: false,
      },
      {
        text: 'Тип поля',
        value: 'type',
        sortable: false,
      },
      {
        text: '',
        sortable: false,
      },
      {
        text: 'Обязательное',
        value: 'required',
        sortable: false,
      },
      {
        text: 'Отображать',
        value: 'required',
        sortable: false,
      },
    ],

    loadingIndicators: false,
    loadingFieldsForIndicator: false,
  }),
  computed: {
    ...mapState('indicators', {
      categories: (state) => state.categories,
      indicators: (state) => state.indicators,
      fieldTypes: (state) => state.fieldTypes,
    }),
    locale () {
      return this.$i18n.locale
    },
    periods () {
      return Object.values(this.$store.getters["periods/periods"])
    },
    itemsForIndicators () {
      let items = []

      if (this.loadingIndicators) {
        return items
      }

      Object.values(this.categories).sort(sortBySequence).forEach((category) => {
        items.push({...category, type: 'category'})

        Object.values(this.indicators).filter((indicator) => {
          return indicator.category === category.code
        }).sort(sortBySequence).forEach((indicator) => {
          items.push({...indicator, type: 'indicator'})

          if (indicator.children) {
            Object.values(indicator.children).sort(sortBySequence).forEach((child) => {
              items.push({ ...child, type: 'indicator' })
            })
          }
        })
      })

      return items
    },
    itemsForIndicatorFields () {
      if (!this.currentIndicator) {
        return []
      }

      let items = []
      if (this.currentIndicator.parent) {
        items = Object.values(this.indicators[this.currentIndicator.parent].children[this.currentIndicator.id].fields).sort(sortBySequence)
      } else {
        items = Object.values(this.indicators[this.currentIndicator.id].fields).sort(sortBySequence)
      }

      return items
    },
  },
  watch: {
    period () {
      this.loadIndicators()
    }
  },
  mounted () {
    this.loadPeriods();
    this.loadIndicators()
  },
  methods: {
    async loadPeriods () {
      await this.$store.dispatch("periods/getPeriods")
    },
    categoryById (id) {
      return Object.values(this.categories).find((category) => {
        return id === category.code
      })
    },
    indicatorById (id) {
      return Object.values(this.indicators).find((indicator) => {
        return id === indicator.id
      })
    },

    loadIndicators () {
      this.loadingIndicators = true
      this.$store.dispatch('indicators/getIndicators', this.period).then(() => {
        this.$events.$emit('notify', {
          message: 'Список индикаторов загружен',
          type: 'info'
        })
      }).catch((error) => {
        this.$events.$emit('notify', {
          message: error.message,
          type: 'error'
        })
      }).finally(() => {
        this.loadingIndicators = false
      })
    },
    expandIndicatorRow (row) {
      let indicator = row.item
      this.loadFieldsForIndicator(indicator)
      row.expanded = true
    },
    loadFieldsForIndicator (indicator) {
      this.loadingFieldsForIndicator = true

      this.$store.dispatch('indicators/getFieldsForIndicator', indicator).then(() => {
        this.currentIndicator = indicator
        this.$events.$emit('notify', {
            message: 'Поля индикатора загружены',
            type: 'info'
          })
      }).catch((error) => {
        this.$events.$emit('notify', {
          message: error.message,
          type: 'error'
        })
      }).finally(() => {
        this.loadingFieldsForIndicator = false
      })
    },

    indicatorDlgOpen (indicator) {
      this.indicator.object = indicator
      this.indicator.dialog = true
    },
    subIndicatorDlgOpen (parent) {
      this.indicator.object = new Indicator()
      this.indicator.object.parent = parent.id
      this.indicator.object.category = parent.category
      this.indicator.dialog = true
    },
    indicatorDlgClose () {
      this.indicator.object = new Indicator()
      this.indicator.dialog = false
    },
    indicatorSave () {
      if (!this.indicator.valid) {
        return
      }
      this.indicator.saving = true
      this.$store.dispatch('indicators/saveIndicator', { indicator: this.indicator.object, period: this.period }).then(() => {
        this.$events.$emit('notify', {
          message: 'Индикатор успешно добавлен',
          type: 'info'
        })
      }).catch((error) => {
        this.$events.$emit('notify', {
          message: error.message,
          type: 'error'
        })
      }).finally(() => {
        this.indicator.saving = false
        this.indicatorDlgClose()
      })
    },

    fieldDlgOpen (field) {
      this.field.object = field
      this.field.dialog = true
    },
    fieldDlgClose () {
      this.field.object = new IndicatorField()
      this.field.dialog = false
    },
    fieldSave () {
      if (this.field.valid) {
        this.field.saving = true
        this.$store.dispatch('indicators/saveField', {indicator: this.currentIndicator, field: this.field.object}).then(() => {
          this.currentIndcator
          this.$events.$emit('notify', {
            message: 'Поле успешно добавлено',
            type: 'info'
          })
        }).catch((error) => {
          this.$events.$emit('notify', {
            message: error.message,
            type: 'error'
          })
        }).finally(() => {
          this.field.saving = false
          this.fieldDlgClose()
        })
      }
    }
  }
}
</script>
